import { types } from '../../types/types'
import AfiliadoService from '../../services/AfiliadoService'
import { startAlerta } from '../ui/alertas'
import { finishSpinner, startSpinner } from '../ui/spinner'
import { actualizarDatosPersonales, desSeleccionarAfiliadoConsulta } from '../afiliado'

export const reactivacionesTraerError = (error) => ({ 
  type: types.afiliadoReactivacionTraerError,
  payload: error
})

export const reactivacionesTraerSuccess = (payload) => {
  return {
    type: types.afiliadoReactivacionTraerSuccess,
    payload: payload
  }
}

export const getAfiliadoReactivaciones = (idAfiliado) => async (dispatch) => {
  dispatch({ type: types.afiliadoReactivacionTraerStart })
  try {
    const result = await AfiliadoService.getReactivaciones(idAfiliado)
    const body = await result.json()
    if (result.ok) {
      dispatch({
        type: types.afiliadoReactivacionTraerSuccess,
        payload: body
      })
    } else {
      throw body.errores
    }
  } catch (error) {
    dispatch({ type: types.afiliadoReactivacionTraerError })
    if (error.mensaje) {
      dispatch(startAlerta(error.mensaje, "error"))
    } else {
      dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
    }
  }
}

export const enviarReactivacionPorLote = (data, idUsuario, fecha, validarDocu, handlerAfterReactivacion = null) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner())
    let result= await AfiliadoService.reactivacionPorLote({idUsuario, afiliados:data, fechaVigencia:fecha, validarDocumentacion: validarDocu })
    const body = await result.json()
    if (result.ok) {
      dispatch(finishSpinner())
      dispatch(startAlerta(`¡Reactivaciones completadas!`,'success','Comando Exitoso'))
      dispatch(desSeleccionarAfiliadoConsulta())
      if (handlerAfterReactivacion !== null) {
        handlerAfterReactivacion();
      }
    } else {
      throw body.errores
    }
    
  } catch (error) {
    dispatch(finishSpinner())
    if (error && error.mensaje) {
      dispatch(startAlerta(error.mensaje, "error"))
    } else {
      dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
    }
  }
}

export const getValidacionDataPersonal = (idAfiliado) => async (dispatch) => {
  try {
    const result = await AfiliadoService.fetchValidarDatosPersonalesReactivacion(idAfiliado)
    if (result.ok) {
      dispatch(actualizarDatosPersonales(true))
    } else {
      dispatch(actualizarDatosPersonales(false))
    }

  } catch (error) {
    dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
  }
}